const Permisos = {
  // EPS
  EPS_VER:      'eps:ver',
  EPS_CREAR:    'eps:crear',
  EPS_EDITAR:   'eps:editar',
  EPS_ELIMINAR: 'eps:eliminar',

  // Especialidad
  ESPECIALIDAD_VER:      'especialidad:ver',
  ESPECIALIDAD_CREAR:    'especialidad:crear',
  ESPECIALIDAD_EDITAR:   'especialidad:editar',
  ESPECIALIDAD_ELIMINAR: 'especialidad:eliminar',

  // Especialidad - SubEspecialidad
  ESPECIALIDADSUBESPECIALIDAD_VER:      'especialidadsubespecialidad:ver',
  ESPECIALIDADSUBESPECIALIDAD_CREAR:    'especialidadsubespecialidad:crear',
  ESPECIALIDADSUBESPECIALIDAD_ELIMINAR: 'especialidadsubespecialidad:eliminar',

  // SubEspecialidad
  SUBESPECIALIDAD_VER:      'subespecialidad:ver',
  SUBESPECIALIDAD_CREAR:    'subespecialidad:crear',
  SUBESPECIALIDAD_EDITAR:   'subespecialidad:editar',
  SUBESPECIALIDAD_ELIMINAR: 'subespecialidad:eliminar',

  // SubEspecialidad - Fellow
  SUBESPECIALIDADFELLOW_VER:      'subespecialidadfellow:ver',
  SUBESPECIALIDADFELLOW_CREAR:    'subespecialidadfellow:crear',
  SUBESPECIALIDADFELLOW_ELIMINAR: 'subespecialidadfellow:eliminar',

  // Fellow
  FELLOW_VER:      'fellow:ver',
  FELLOW_CREAR:    'fellow:crear',
  FELLOW_EDITAR:   'fellow:editar',
  FELLOW_ELIMINAR: 'fellow:eliminar',

  // Universidad
  UNIVERSIDAD_VER:      'universidad:ver',
  UNIVERSIDAD_CREAR:    'universidad:crear',
  UNIVERSIDAD_EDITAR:   'universidad:editar',
  UNIVERSIDAD_ELIMINAR: 'universidad:eliminar',

  // Tipo Afiliacion
  TIPOAFILIACION_VER:      'tipoafiliacion:ver',
  TIPOAFILIACION_CREAR:    'tipoafiliacion:crear',
  TIPOAFILIACION_EDITAR:   'tipoafiliacion:editar',
  TIPOAFILIACION_ELIMINAR: 'tipoafiliacion:eliminar',

  // Diagnostico
  DIAGNOSTICO_VER:      'diagnostico:ver',
  DIAGNOSTICO_CREAR:    'diagnostico:crear',
  DIAGNOSTICO_EDITAR:   'diagnostico:editar',
  DIAGNOSTICO_ELIMINAR: 'diagnostico:eliminar',

  // Diagnostico - Producto
  DIAGNOSTICOPRODUCTO_VER:      'diagnosticoproducto:ver',
  DIAGNOSTICOPRODUCTO_CREAR:    'diagnosticoproducto:crear',
  DIAGNOSTICOPRODUCTO_ELIMINAR: 'diagnosticoproducto:eliminar',

  // Institucion
  INSTITUCION_VER:      'institucion:ver',
  INSTITUCION_CREAR:    'institucion:crear',
  INSTITUCION_EDITAR:   'institucion:editar',
  INSTITUCION_ELIMINAR: 'institucion:eliminar',

  // Paciente
  PACIENTE_VER:      'paciente:ver',
  PACIENTE_CREAR:    'paciente:crear',
  PACIENTE_EDITAR:   'paciente:editar',
  PACIENTE_ELIMINAR: 'paciente:eliminar',

  // Paciente - Archivo Adjunto
  PACIENTEADJUNTO_VER:      'pacienteadjunto:ver',
  PACIENTEADJUNTO_CREAR:    'pacienteadjunto:crear',
  PACIENTEADJUNTO_ELIMINAR: 'pacienteadjunto:eliminar',

  // Cirujano
  CIRUJANO_VER:      'cirujano:ver',
  CIRUJANO_CREAR:    'cirujano:crear',
  CIRUJANO_EDITAR:   'cirujano:editar',
  CIRUJANO_ELIMINAR: 'cirujano:eliminar',

  // Cirujano - Ciudad
  CIRUJANO_CIUDAD_VER:      'cirujano_ciudad:ver',
  CIRUJANO_CIUDAD_CREAR:    'cirujano_ciudad:crear',
  CIRUJANO_CIUDAD_ELIMINAR: 'cirujano_ciudad:eliminar',

  // Cirujano - Institucion
  CIRUJANOINSTITUCION_VER:      'cirujanoinstitucion:ver',
  CIRUJANOINSTITUCION_CREAR:    'cirujanoinstitucion:crear',
  CIRUJANOINSTITUCION_ELIMINAR: 'cirujanoinstitucion:eliminar',

  // Cirujano - Adjunto
  CIRUJANOADJUNTO_VER:      'cirujanoadjunto:ver',
  CIRUJANOADJUNTO_CREAR:    'cirujanoadjunto:crear',
  CIRUJANOADJUNTO_ELIMINAR: 'cirujanoadjunto:eliminar',

  // Cirujano - Firma
  CIRUJANOFIRMA_VER:      'cirujanofirma:ver',
  CIRUJANOFIRMA_CREAR:    'cirujanofirma:crear',
  CIRUJANOFIRMA_ELIMINAR: 'cirujanofirma:eliminar',

  // Prepedido
  PREPEDIDO_VER:      'prepedido:ver',
  PREPEDIDO_CREAR:    'prepedido:crear',
  PREPEDIDO_EDITAR:   'prepedido:editar',
  PREPEDIDO_ELIMINAR: 'prepedido:eliminar',

  // Prepedido - Adjunto
  PREPEDIDOADJUNTO_VER:      'prepedidoadjunto:ver',
  PREPEDIDOADJUNTO_CREAR:    'prepedidoadjunto:crear',
  PREPEDIDOADJUNTO_ELIMINAR: 'prepedidoadjunto:eliminar',

  // Prepedido - Imagen
  PREPEDIDOIMAGEN_VER:      'prepedidoimagen:ver',
  PREPEDIDOIMAGEN_CREAR:    'prepedidoimagen:crear',
  PREPEDIDOIMAGEN_ELIMINAR: 'prepedidoimagen:eliminar',

  // Asignacion Soporte Quirurgico
  ASIGNACIONSOPORTEQUIRURGICO_VER:      'asignacionsoportequirurgico:ver',
  ASIGNACIONSOPORTEQUIRURGICO_CREAR:    'asignacionsoportequirurgico:crear',
  ASIGNACIONSOPORTEQUIRURGICO_EDITAR:   'asignacionsoportequirurgico:editar',
  ASIGNACIONSOPORTEQUIRURGICO_ELIMINAR: 'asignacionsoportequirurgico:eliminar',

  // Reporte Gasto
  REPORTEGASTO_VER:      'reportegasto:ver',
  REPORTEGASTO_CREAR:    'reportegasto:crear',
  REPORTEGASTO_EDITAR:   'reportegasto:editar',
  REPORTEGASTO_ELIMINAR: 'reportegasto:eliminar',

  // Reporte Gasto - Composicion
  REPORTEGASTOCOMPOSICION_VER:    'reportegastocomposicion:ver',
  REPORTEGASTOCOMPOSICION_EDITAR: 'reportegastocomposicion:editar',

  // Reporte Gasto - Bodega Institucion
  REPORTEGASTOBODEGAINSTITUCION_VER:      'reportegastobodegainstitucion:ver',
  REPORTEGASTOBODEGAINSTITUCION_CREAR:    'reportegastobodegainstitucion:crear',
  REPORTEGASTOBODEGAINSTITUCION_EDITAR:   'reportegastobodegainstitucion:editar',
  REPORTEGASTOBODEGAINSTITUCION_ELIMINAR: 'reportegastobodegainstitucion:eliminar',

  // Reporte Gasto - Bioseguridad
  REPORTEGASTOBIOSEGURIDAD_VER:      'reportegastobioseguridad:ver',
  REPORTEGASTOBIOSEGURIDAD_CREAR:    'reportegastobioseguridad:crear',
  REPORTEGASTOBIOSEGURIDAD_ELIMINAR: 'reportegastobioseguridad:eliminar',

  // Reporte Gasto - Firma
  REPORTEGASTOFIRMA_VER: 'reportegastofirma:ver',

  // Reporte Gasto - Imagen
  REPORTEGASTOIMAGEN_VER:      'reportegastoimagen:ver',
  REPORTEGASTOIMAGEN_CREAR:    'reportegastoimagen:crear',
  REPORTEGASTOIMAGEN_ELIMINAR: 'reportegastoimagen:eliminar',

  // Reporte Gasto - Archivo Adjunto
  REPORTEGASTOADJUNTO_VER:      'reportegastoadjunto:ver',
  REPORTEGASTOADJUNTO_CREAR:    'reportegastoadjunto:crear',
  REPORTEGASTOADJUNTO_ELIMINAR: 'reportegastoadjunto:eliminar',

  // Rol
  ROL_VER:      'rol:ver',
  ROL_CREAR:    'rol:crear',
  ROL_EDITAR:   'rol:editar',
  ROL_ELIMINAR: 'rol:eliminar',
};

export default Permisos;
